import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Tour } from 'src/classes/tour';

@Component({
  selector: 'app-tour-list',
  templateUrl: './tour-list.component.html',
  styleUrls: ['./tour-list.component.css'],
  standalone: false,
})
export class TourListComponent {
  @Input() tourList: {
    title: string;
    tours: Tour[];
  };

  constructor(
    private router: Router,
  ) {}

  redirectArticle(url) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  }
}
